module.exports = __webpack_public_path__ + "media/images/TinyCreditCard-e8f3c3d5.svg";